module.exports = __webpack_public_path__ + "static/jr_dev_resume-ce07eb82cda31e8eb201cf6b49a7d322.pdf";